import axios from "axios";

const patientsUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/patients/backoffice`;
const patientsManagerUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/patients`;
const patientsBaseUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api`;
const linkSaleUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/link-sale`;

const normalizeDirectSaleSex = (sex) => {
  if (typeof sex === "string") {
    const normalized = sex.trim().toUpperCase();
    if (["MALE", "FEMALE", "NON_BINARY"].includes(normalized)) {
      return normalized;
    }
    if (normalized === "HOMBRE") return "MALE";
    if (normalized === "MUJER") return "FEMALE";
    if (normalized === "NO_BINARIO") return "NON_BINARY";
  }

  if (sex === 1 || sex === "1") return "MALE";
  if (sex === 2 || sex === "2") return "FEMALE";
  if (sex === 3 || sex === "3") return "NON_BINARY";

  return sex;
};

const buildDirectSalePayload = (data = {}) => {
  const payload = {
    email: data.email ?? data.mail,
    phoneNumber: data.phoneNumber ?? data.phone ?? data.telCelular,
    firstName: data.firstName ?? data.nombre,
    lastName: data.lastName ?? data.apellido,
    dni: data.dni ?? data.id_number ?? data.documento,
    birthDate: data.birthDate ?? data.fechaDeNacimiento,
    sex: normalizeDirectSaleSex(data.sex ?? data.sexo),
    idPlan: data.idPlan ?? data.financer_plan ?? data.financerPlanId,
    tarjetaNumero: data.tarjetaNumero,
    tarjetaTitular: data.tarjetaTitular,
    tarjetaFechaVencimiento: data.tarjetaFechaVencimiento,
    idTarjeta: data.idTarjeta,
    cbu: data.cbu,
    cbuTitular: data.cbuTitular,
  };

  return Object.fromEntries(
    Object.entries(payload).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );
};

const buildPatientsUrl = (params = {}) => {
  const query = new URLSearchParams();

  // backoffice-v3: "search" busca por email o DNI (el DNI va sin puntos),
  // "nameSearch" por nombre/apellido. Son combinables. Ambos son parciales
  // (LIKE) por defecto; con exactMatch=true el matcheo es exacto y más rápido.
  if (params.search) {
    const term = params.search.trim();
    query.append(
      "search",
      /^[\d.]+$/.test(term) ? term.replace(/\./g, "") : term
    );
  }
  if (params.nameSearch) query.append("nameSearch", params.nameSearch.trim());
  if (params.exactMatch) query.append("exactMatch", true);
  if (params.activated)
    query.append("activated", params.activated === "ACTIVO");
  if (params.financerPlan) query.append("financerPlan", params.financerPlan);
  if (params.financer) query.append("financer", params.financer);
  if (params.page) query.append("page", params.page);
  if (params.size) query.append("size", params.size);
  return `${patientsUrl}-v3${
    query.toString() ? `?${query.toString()}` : ""
  }`;
};

export const getPatientAdditionalData = async (token, patientId,product) => {
  return await axios
    .get(`${patientsUrl}/get-additional-data/${patientId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // if (token) displayError("getPatients error: " + error.message);
    });
};



export const getPatients = async (token, displayError = () => {}, params) => {
  // let url = `${patientsUrl}${params?.query || params?.page ? "?" : ""}${
  //   params?.query && params?.query !== "" ? `search=` + params?.query : ``
  // }${params?.query && params?.page ? `&` : ""}${
  //   params?.page ? `page=` + params?.page : ``
  //   }`;
  return await axios
    .get(buildPatientsUrl(params), {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("getPatients error: " + error.message);
    });
};

export const editPatient = async (token, data, displayError = () => {}) => {
  return await axios
    .put(`${patientsUrl}/${data?.id}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("editPatient error: " + error.message);
    });
};

export const activatePatient = async (token, data, displayError = () => {}) => {
  const sellerToken = data?.sellerToken;
  if (sellerToken) {
    const salesPointId = data?.salesPointId;
    const url = salesPointId
      ? `${linkSaleUrl}/${encodeURIComponent(sellerToken)}?salesPointId=${encodeURIComponent(salesPointId)}`
      : `${linkSaleUrl}/${encodeURIComponent(sellerToken)}`;

    return await axios
      .post(url, buildDirectSalePayload(data), {
        headers: { authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        const message = error?.response?.data?.error || error?.message || "activatePatient error";
        if (token) displayError(message);
      });
  }

  return await axios
    .post(
      `${patientsUrl}/${data?.id}`,
      { ...data, activated: true },
      { headers: { authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("activatePatient error: " + error.message);
    });
};
export const disablePatient = async (
  token,
  id,
  reason,
  product = "mediline",
  notify = true,
  displayError = () => {}
) => {
  return await axios
    .delete(`${patientsUrl}/${id}/${reason}${notify ? "" : "?notify=false"}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // 409: ya había una baja pendiente para este socio. No es un error real
      // -> se devuelve el body (trae effectiveDate) para que el caller lo distinga.
      if (error?.response?.status === 409) {
        return error.response.data;
      }
      if (token) displayError("disablePatient error: " + error.message);
    });
};

// Info de una baja pendiente (cooling-off) para mostrarla en el backoffice:
// mismo id que usa el link público de arrepentimiento. planName y price
// pueden venir null (resolución best-effort contra parametrics).
export const getPendingUnsubscriptionInfo = async (
  token,
  unsubscriptionId,
  displayError = () => {}
) => {
  return await axios
    .get(`${patientsBaseUrl}/patients/deactivate/regret/${unsubscriptionId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      displayError("getPendingUnsubscriptionInfo error: " + error.message);
    });
};

// El alta (POST /patients/backoffice/create) siempre falla con 400 y tres formas
// posibles de body. `message`, `title` y el header X-userprofileApp-error son claves
// de i18n, no texto para el usuario: no se leen.
const CREATE_PATIENT_GENERIC_ERROR =
  "No se pudo completar el alta. Intentá nuevamente.";

// `detail` que el back manda cuando no sabe qué pasó: no aporta nada al operador.
const USELESS_ERROR_DETAILS = [
  "Unexpected runtime exception",
  "Unable to convert http message",
];

// Devuelve { tipo: "campos", errores: [{ field, message }] } cuando el 400 trae
// fieldErrors (validación y reglas de negocio: mail duplicado, DNI en uso, plan no
// bonificado), y { tipo: "general", mensaje } para fallas de infra o JSON ilegible.
export const parseCreatePatientError = (error) => {
  const problem = error?.response?.data;
  if (problem?.fieldErrors?.length) {
    return { tipo: "campos", errores: problem.fieldErrors };
  }
  const detail = problem?.detail;
  if (detail && !USELESS_ERROR_DETAILS.includes(detail)) {
    return { tipo: "general", mensaje: detail };
  }
  return { tipo: "general", mensaje: CREATE_PATIENT_GENERIC_ERROR };
};

export const createPatient = async (token, data, displayError = () => {}) => {
  return await axios
    .post(`${patientsUrl}/create`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) {
        const parsed = parseCreatePatientError(error);
        displayError(
          parsed.tipo === "campos"
            ? parsed.errores.map((fieldError) => fieldError.message).join(" ")
            : parsed.mensaje
        );
      }
    });
};

// Alta de socio bonificado (BNF). A diferencia de createPatient, no muestra el error
// por toast: devuelve el problema parseado para que el formulario pinte cada
// fieldError en su input.
export const createBnfPatient = async (token, data) => {
  return await axios
    .post(`${patientsUrl}/create`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return { ok: true, data: response.data };
    })
    .catch((error) => {
      return { ok: false, error: parseCreatePatientError(error) };
    });
};

export const validatePatientExist = async (
  token,
  mail,
  dni,
  product = "mediline",
  displayError = () => {}
) => {
  return await axios
    .get(
      `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/t-motos/validar-usuario?dni=${dni}&mail=${mail}`,
      {
        headers: { authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("activatePatient error: " + error.message);
    });
};

export const getFinancerPlans = async (
  token,
  displayError = () => {},
  product = "mediline"
) => {
  let url = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/financer-plans`;
  return await axios
    .get(url, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (token) displayError("getFinancerPlans error: " + error.message);
    });
};

export const importPatients = async (token, data, displayError = () => {}) => {
  return await axios
    .post(`${patientsBaseUrl}/patient-import-file`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("importPatient error: " + error.message);
    });
};

export const importPatientsGigaRed = async (
  token,
  data,
  displayError = () => {}
) => {
  return await axios
    .post(
      `${patientsBaseUrl}/patient-import-file-gigared`,
      data,
      {
        headers: { authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("importPatient error: " + error.message);
    });
};

export const patientByDni = async ( data) => {
  return await axios
    .post(`${patientsBaseUrl}/patients/patientByDni`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("patientByDni error: " + error.message);
      return error?.response?.data;
    });
};
